import React, { FC, PropsWithChildren } from 'react';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div style={{ margin: `0 auto`, padding: `0 1rem`, paddingBottom: '2rem', display: 'flow-root' }} className="ix-blog-content">
      {children}
    </div>
  );
};
